const FieldValidationError = (props) => {
    return (
        (props.error && (<div
            className="invalid-feedback animated fadeInUp"
            style={{ display: "block" }}
        >
            {props.error}
        </div>))
    );
}

export default FieldValidationError;